import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { SiteConfig } from '../interfaces/site-config.interface';

@Injectable({
  providedIn: 'root',
})
export class SiteConfigService {
  private config$ = new BehaviorSubject<SiteConfig | null>(null);
  private configLoaded = false;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<SiteConfig> {
    if (this.configLoaded && this.config$.value) {
      return of(this.config$.value);
    }

    return this.http.get<SiteConfig>('./assets/config/site.config.json').pipe(
      tap((config) => {
        this.config$.next(config);
        this.configLoaded = true;
      }),
      catchError((error) => {
        console.error('Failed to load site config, using defaults', error);
        const defaultConfig: SiteConfig = {
          name: 'ResistMap',
        };
        this.config$.next(defaultConfig);
        return of(defaultConfig);
      }),
    );
  }

  getConfig(): Observable<SiteConfig | null> {
    return this.config$.asObservable();
  }

  getCurrentConfig(): SiteConfig | null {
    return this.config$.value;
  }

  // This method will be used when we integrate with a CMS
  updateConfig(newConfig: SiteConfig): void {
    this.config$.next(newConfig);
  }
}
